(() => {
  const placements = new Map();
  let retryTimer;

  function updateMessages(root) {
    root.querySelectorAll('[part~="osm-logo"]').forEach((logo) => {
      // Remove the previous static-logo Tab stop, preserving native controls.
      if (logo.querySelector('[part~="osm-logo"]')) return;
      if (logo.textContent.trim() !== 'Klarna') return;
      if (logo.closest('a[href], button, [role="button"], [role="link"]')) return;
      if (logo.getAttribute('tabindex') === '0') {
        logo.removeAttribute('tabindex');
      }
    });

    root.querySelectorAll('[part~="osm-message"]').forEach((message) => {
      const text = message.textContent.replace(/\s+/g, ' ').trim();
      if (!text) {
        if (message.dataset.klarnaReadable === 'true') {
          message.removeAttribute('tabindex');
          message.removeAttribute('aria-label');
          message.removeAttribute('role');
          delete message.dataset.klarnaReadable;
        }
        return;
      }
      // Keep Klarna's actual controls intact if the provider changes its markup.
      if (message.matches('a[href], button, [role="button"], [role="link"]')) return;
      message.dataset.klarnaReadable = 'true';
      if (message.getAttribute('tabindex') !== '0') message.setAttribute('tabindex', '0');
      if (message.getAttribute('role') !== 'group') message.setAttribute('role', 'group');
      if (message.getAttribute('aria-label') !== text) message.setAttribute('aria-label', text);
    });
  }

  function connectRoots() {
    let waiting = false;
    placements.forEach((observer, placement) => {
      if (!placement.isConnected) {
        observer?.disconnect();
        placements.delete(placement);
        return;
      }
      if (observer) return;
      const root = placement.shadowRoot;
      if (!root) {
        waiting = true;
        return;
      }
      updateMessages(root);
      const rootObserver = new MutationObserver(() => updateMessages(root));
      rootObserver.observe(root, {
        childList: true,
        subtree: true,
        characterData: true,
        attributes: true,
        attributeFilter: ['part', 'tabindex'],
      });
      placements.set(placement, rootObserver);
    });

    // Shadow root attachment does not trigger a document MutationObserver.
    if (waiting && !retryTimer) retryTimer = setInterval(connectRoots, 500);
    if (!waiting && retryTimer) {
      clearInterval(retryTimer);
      retryTimer = undefined;
    }
  }

  function discover(node) {
    if (node.nodeType !== Node.ELEMENT_NODE) return;
    const found = node.matches('klarna-placement') ? [node] : [];
    found.push(...node.querySelectorAll('klarna-placement'));
    found.forEach((placement) => {
      if (!placements.has(placement)) placements.set(placement, null);
    });
  }

  discover(document.documentElement);
  connectRoots();
  new MutationObserver((records) => {
    records.forEach((record) => record.addedNodes.forEach(discover));
    connectRoots();
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
